import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationSerializer from 'lumen/serializers/application';

export default class BudgetForecastDataItemSerializer extends ApplicationSerializer {
  attrs = {
    parent: 'parent_id',
    budget: 'budget_id',
    forecast: 'forecast_id',
    segment: 'segment_id',
    _revenue: 'revenue',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('budget-forecast/data-item');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // The dayjs transform returns a string in the format YYYY-MM-DDTHH:mm:ssZ
  // We need to convert it to a string in the format YYYY-MM-DD to match the API spec
  serialize(snapshot: Snapshot, options: object): Record<string, unknown> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const payload: Record<string, unknown> = super.serialize(snapshot, options);

    if (typeof payload['date'] === 'string') {
      payload['date'] = payload['date'].split('T')[0];
    }

    return payload;
  }
}
